import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import ScienceIcon from '@mui/icons-material/Science';
import SchoolIcon from '@mui/icons-material/School';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const item: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
        <Box
          component="img"
          src="/static/themes/ChemQuiz/productCurvyLines.png"
          alt="curvy lines"
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <ScienceIcon sx={{ fontSize: 55, color: 'primary.main' }} />
              <Typography variant="h6" sx={{ my: 5 }}>
                Углубленные знания
              </Typography>
              <Typography variant="h5">
                {
                  'Расширьте свои знания в области химии, решая интересные и сложные задачи.'
                }
                {
                  ' Получите опыт работы с реальными химическими проблемами.'
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <SchoolIcon sx={{ fontSize: 55, color: 'primary.main' }} />
              <Typography variant="h6" sx={{ my: 5 }}>
                Подготовка к будущему
              </Typography>
              <Typography variant="h5">
                {
                  'Участие в олимпиаде - это отличная подготовка к поступлению в ведущие вузы '
                }
                {'и начало научной карьеры.'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={item}>
              <EmojiEventsIcon sx={{ fontSize: 55, color: 'primary.main' }} />
              <Typography variant="h6" sx={{ my: 5 }}>
                Престижные награды
              </Typography>
              <Typography variant="h5">
                {'Победители получают дипломы, ценные призы и возможность '}
                {'участвовать в международных соревнованиях.'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
